function cacheBustUrl(url) {
  const ver = Math.floor(Date.now() / 1000);
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}ver=${ver}`;
}

/** Known deploy / gateway bases. Same list as src/index.js (longest match wins). */
const KNOWN_BASES = ['/chatbots', process.env.REACT_APP_BASENAME];

function resolveAppBase() {
  const fromEnv = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  if (fromEnv) return fromEnv;
  if (typeof window === 'undefined') return '';
  const pathname = window.location.pathname;
  const match = [...KNOWN_BASES]
    .filter(Boolean)
    .sort((a, b) => b.length - a.length)
    .find((base) => pathname === base || pathname.startsWith(`${base}/`));
  return match || '';
}

/** Prefix app-root paths (e.g. /jsons/...) with PUBLIC_URL or runtime /chatbots base. */
export function resolveAppStaticUrl(pathOrUrl, fallbackPath = '') {
  const base = resolveAppBase();
  const raw =
    typeof pathOrUrl === 'string' && pathOrUrl.trim()
      ? pathOrUrl.trim()
      : fallbackPath;
  if (!raw) return fallbackPath || '';
  if (/^https?:\/\//i.test(raw)) return raw;
  const path = raw.startsWith('/') ? raw : `/${raw}`;
  if (base && (path === base || path.startsWith(`${base}/`))) return path;
  return `${base}${path}`;
}

export async function fetchStaticJson(url) {
  const link = cacheBustUrl(url);
  const res = await fetch(link);

  if (!res.ok) {
    throw new Error(`Failed to fetch json url: ${url} with status: ${res.status}`);
  }

  return res.json();
}
